module.exports = __webpack_public_path__ + "img/flasks.ea300b67.png";